const ANNUL_SALE_ACTION =  "Anular Ticket"
const CREATE_NEW_USER = "Registrar Cliente"
const CLEAN_TICKET = 'Limpiar Ticket'
export { 
    ANNUL_SALE_ACTION,
    CREATE_NEW_USER ,
    CLEAN_TICKET
}